import { boolean, object, string } from 'yup';

export function getShortBusinessInfoSchema() {
  return object().shape({
    companyName: string(),
    businessType: string(),
    businessSize: string(),
    businessSector: string(),
    doNotShowAgain: boolean(),
  });
}
